import { FileOutlined, FolderOpenFilled } from "@ant-design/icons";
import FolderIcon from "@src/styles/icon/folder-icon.svg";
import { Col, Empty, Row, Tree } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useState } from "react";
import TitlePage from "../../component/Desktop/titlePage";
import { lang } from "../../constants/common.const";
import FolderTreeComponent from "../../component/tree-folder/TreeFolderComponent";
// import "./equipmentMaster.scss";
const { DirectoryTree } = Tree;

export const removeTopLayer = (data) => {
  return data.flatMap((item) => item.children || []);
};
export const filterData = (data, code) => {
  return data.filter((i) => i.code === code);
};
const transformData = (data, parentKey = "", expandedKeys = []) => {
  return data.map((item, index) => {
    const key = parentKey !== "" ? `${parentKey}-${item.code}` : `${item.code}`;
    const isOpen = expandedKeys.includes(key);
    const hasChildren =
      Array.isArray(item.children) && item.children.length > 0;

    return {
      title: (
        <span
          style={{
            marginLeft: 5,
          }}
        >
          {item.title}
        </span>
      ),
      name: item.title,
      key: key,
      code: item.code,
      order: key.split("-").length,
      icon: hasChildren ? (
        !isOpen ? (
          <img
            style={{ width: 20, height: 20 }}
            src={FolderIcon}
            alt=""
            className="icon__confirm"
          />
        ) : (
          <FolderOpenFilled style={{ color: "#0080cb", fontSize: 23 }} />
        )
      ) : (
        <FileOutlined style={{ fontSize: 16 }} />
      ),
      isLeaf: !hasChildren,
      children: hasChildren
        ? transformData(item.children, key, expandedKeys)
        : undefined,
    };
  });
};

const EquipmentFolderTree = ({
  data,
  expandedKeys,
  setExpandedKeys = () => {},
  onSelect = () => {},
  listSelects = [],
  listExpands = [],
  setListSelects,
  setListExpands,
  ...others
}) => {
  const [currentNode, setCurrentNode] = useState({});

  const handleSelect = (keys, info) => {
    setCurrentNode(info.node);
    onSelect(info.node);
  };

  const handleExpand = (keys) => {
    setExpandedKeys(keys);
  };

  return (
    <div>
      <FolderTreeComponent
        listSelects={listSelects}
        listExpands={listExpands}
        setListSelects={setListSelects}
        setListExpands={setListExpands}
        data={data}
        onSelect={handleSelect}
        onExpand={handleExpand}
        draggable={true}
        {...others}
      />
    </div>
  );
};
export default EquipmentFolderTree;
